import { Fragment } from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { Dumbbell } from "lucide-react";

import ContentFrame from 'components/Frame/ContentFrame'
import AssessmentListItem from 'components/Assessment/AssessmentListItem'
import WorkoutListItem from 'components/Workout/WorkoutListItem'
import WorkoutV5ListItem from 'components/Workout/WorkoutV5ListItem'

export default function RecentActivity({ recentActivity = null }) {

    if (recentActivity === null) return <></>

    const GetActivityListItem = (recentActivityItem) => {
        if (recentActivityItem.type === 'assessment') {
            return <AssessmentListItem assessment={recentActivityItem} />
        }

        if (recentActivityItem.type === 'workout' && recentActivityItem.boilerplate === true) {
            return <WorkoutV5ListItem workout={recentActivityItem} />
        }

        if (recentActivityItem.type === 'workout') {
            return <WorkoutListItem workout={recentActivityItem} />
        }

        return null
    }

    return (
        <ContentFrame
            className='divide-y divide-gray-200'
            titleText="Recent Activity"
            titleIcon={<InformationCircleIcon className="mt-0.5 w-5 h-5 text-gray-800" />}
            toolTipText="Most recent activity completed across your athlete roster"
        >
            {recentActivity.length === 0 &&
                <div className="h-full flex flex-col items-center justify-center py-16 space-y-2">
                    <Dumbbell className="h-16 w-16 text-gray-300 mb-4" />

                    <p className="text-sm text-gray-500 text-center">No activity yet</p>

                    <p className="text-sm text-gray-500 text-center">Have athletes start training to see their activity here</p>
                </div> 
            }
            
            {recentActivity.length > 0 && recentActivity.map((recentActivityItem, index) => (
                <Fragment key={index}>
                    {GetActivityListItem(recentActivityItem)}
                </Fragment>
            ))}
        </ContentFrame>
    )
}
